
import Config from "../../../core/core/calcule/Config"
import UiUtil from "../../../utils/UiUtil"
import TimeLineNodeType from "../../datatype/TimeLineNodeType"
import TimeDotElementContent from "../../mindelementdata/mindcontent/TimeDotElementContent"
import TimeLineLayout from "./TimeLineLayout"
import BaseLayout from "./BaseLayout"
import TimeNodeLayoutType from "../../datatype/TimeNodeLayoutType"
import Util from "../../../utils/Util"
/**
 * ProjectName: MindMap
 * Created by tony on 2020/7/4
 * Copyright(c) 2020 mindyushu.com
 */

class TimeLineBridgeLayout extends TimeLineLayout {
    constructor() {
        super();
        this.UiUtil = new UiUtil();
        this.BaseLayout = new BaseLayout();
        this.baseLineHeight = this.UiUtil.dip2px(10);
        this.nodeLinePadding = this.UiUtil.dip2px(10);
        this.nodeLineVertical = this.UiUtil.dip2px(5);
    }

    initConfigInfo() {
        this.radius = 0;//this.getRadius();
        this.baseLineHeight = this.UiUtil.dip2px(this.baseLine.timeLineContent.lineWidth) + this.UiUtil.dip2px(10);
        this.baseLineTitleSpace = this.UiUtil.dip2px(10) + this.UiUtil.dip2px(this.baseLine.timeLineContent.lineWidth);

        this.subjectAndLineSpace = 0//addSubjectSpcaeVertical(0);
        this.sonSubjectAndLineSpace = this.addSonSubjectSpcaeVertical(0);
        this.timeNodeLayoutType = TimeNodeLayoutType.HEAD_TITLE_MIDDLE_BOTTOM;
        let descWidth = Math.max(this.getDescMaxWidth(), this.UiUtil.dip2px(50))
        this.subjectSpace = this.addSubjectSpcaeHorizontal(Math.min(descWidth, this.UiUtil.dip2px(100)));
        this.firstSubjectBaseLineTopSpace = this.UiUtil.dip2px(8);
    }

    setElementsPoint(isChange) {
        if (!isChange && this.title.x < 0) {
            let left = (Config.Mind_Width - this.UiUtil.getScreenWidth()) / 2;
            let top = (Config.Mind_Height - this.UiUtil.getScreenHeight()) / 2;
            this.title.y = (top) + this.title.height + 20;
            this.title.x = (this.UiUtil.getScreenWidth() - (this.title.width)) / 2 + left;
        }
        this.initConfigInfo();
        let nodeList = this.getOrderNodes();
        let nodeListLength = nodeList.length;

        let left = this.title.x;
        let contentY = this.title.y + this.title.height + this.UiUtil.dip2px(50);
        if (nodeListLength > 0) {
            contentY += nodeList[0].head.height
        }
        this.baseLine.x = this.title.x;
        if (!this.isBackgroundAndBorder(this.title)) {            
            this.baseLine.x = this.title.x + this.getTextEdgeInsets(this.title).left;
            left = this.baseLine.x;
        }
        this.baseLine.y = contentY - this.baseLineHeight / 2;
        this.space = (this.baseLineHeight - this.radius) / 2;

        
        for (let index = 0; index < nodeListLength; index++) {
            let timeNode = nodeList[index];
            let head = timeNode.head;
            let title = timeNode.title;
            let desc = timeNode.desc;

            head.isHidden = false;
            title.isHidden = false;
            desc.isHidden = index == (nodeListLength - 1);
            
            let nodeWidth = this.getTimeMindTypeNodeWidthByHorizontal(timeNode);
            if (index == 0) {
                head.x = left + (nodeWidth - head.width) / 2 + this.nodeLinePadding;
                title.x = left + (nodeWidth - title.width) / 2 + this.nodeLinePadding;
                desc.x = left + nodeWidth + this.nodeLinePadding * 2 + (this.subjectSpace - desc.width)/2;
            } else {
                head.x = left + this.subjectSpace + (nodeWidth - head.width) / 2 + this.nodeLinePadding;
                title.x = left + this.subjectSpace + (nodeWidth - title.width) / 2 + this.nodeLinePadding;
                desc.x = left + this.subjectSpace + nodeWidth + this.nodeLinePadding * 2 + (this.subjectSpace - desc.width)/2;
            }
            head.y = this.baseLine.y + this.baseLineHeight/2 - this.baseLine.timeLineContent.lineWidth/2 - this.nodeLineVertical - head.height;
            title.y = this.baseLine.y + this.baseLineHeight/2 + this.baseLine.timeLineContent.lineWidth/2 + this.nodeLineVertical;
            if (this.isBackgroundAndBorder(desc)) {
                desc.y = this.baseLine.y + this.baseLineHeight/2 - desc.height;
            } else {
                desc.y = this.baseLine.y + this.baseLineHeight/2 - desc.height + 
                    this.getTextEdgeInsets(desc).bottom + (desc.height - desc.textContent.y - desc.textContent.height) + 4;
            }
            if (index == 0) {
                left += nodeWidth + this.nodeLinePadding * 2;
            } else {
                left += nodeWidth + this.nodeLinePadding * 2 + this.subjectSpace;
            }
            
        }

        this.baseLine.width = left - this.baseLine.x;
        this.baseLine.height = this.baseLineHeight;

        this.baseLine.timeLineContent.lineContentWidth = this.baseLine.width;
        this.baseLine.timeLineContent.lineContentHeight = this.baseLineHeight;

        let dots = new Array();

        for (let index = 0; index < nodeListLength; index++) {
            let timeNode = nodeList[index];
            let head = timeNode.head;
            let title = timeNode.title;
            let dotElementContent = new TimeDotElementContent();
            dotElementContent.targetId = timeNode.id;
            dotElementContent.radius = this.radius;
            if (this.settingData.useTimeLineColor) {
                dotElementContent.color = this.baseLine.timeLineContent.color;
            } else {
                dotElementContent.color = this.getHeadConnectLineColor(head, timeNode.title);
            }

            if (index == 0) {
                dotElementContent.x = Math.min(title.x, head.x) - this.nodeLinePadding - this.baseLine.x;
                dotElementContent.y = this.baseLineHeight / 2;
                dots.push(dotElementContent);

                let dotElementContent2 = new TimeDotElementContent();
                dotElementContent2.targetId = timeNode.id;
                dotElementContent2.radius = this.radius;
                if (this.settingData.useTimeLineColor) {
                    dotElementContent2.color = this.baseLine.timeLineContent.color;
                } else {
                    dotElementContent2.color = this.getHeadConnectLineColor(head, timeNode.title);
                }
                dotElementContent2.x = Math.max(title.x + title.width, head.x + head.width) + this.nodeLinePadding - this.baseLine.x;
                dotElementContent2.y = this.baseLineHeight / 2;
                dots.push(dotElementContent2);
            }  else {
                let bridgeHeight = Util.tan(50) * (this.subjectSpace / 2)
                bridgeHeight = Math.min(bridgeHeight, this.UiUtil.dip2px(40))
                dotElementContent.x = Math.min(title.x, head.x) - this.nodeLinePadding - this.subjectSpace / 2 - this.baseLine.x;
                dotElementContent.y = this.baseLineHeight / 2 - bridgeHeight;
                dots.push(dotElementContent);

                let dotElementContent2 = new TimeDotElementContent();
                dotElementContent2.targetId = timeNode.id;
                dotElementContent2.radius = this.radius;
                if (this.settingData.useTimeLineColor) {
                    dotElementContent2.color = this.baseLine.timeLineContent.color;
                } else {
                    dotElementContent2.color = this.getHeadConnectLineColor(head, timeNode.title);
                }

                dotElementContent2.x = Math.min(title.x, head.x) - this.nodeLinePadding - this.baseLine.x;
                dotElementContent2.y = this.baseLineHeight / 2;
                dots.push(dotElementContent2);

                let dotElementContent3 = new TimeDotElementContent();
                dotElementContent3.targetId = timeNode.id;
                dotElementContent3.radius = this.radius;
                if (this.settingData.useTimeLineColor) {
                    dotElementContent3.color = this.baseLine.timeLineContent.color;
                } else {
                    dotElementContent3.color = this.getHeadConnectLineColor(head, timeNode.title);
                }
                dotElementContent3.x = Math.max(title.x + title.width, head.x + head.width) + this.nodeLinePadding - this.baseLine.x;
                dotElementContent3.y = this.baseLineHeight / 2;
                dots.push(dotElementContent3);
            }           
        }
        this.baseLine.timeLineContent.dots = this.getOrderDot(dots);
    }

    getOrderDot(dots) {
        let list = new Array();
        dots.forEach(node => {
            list.push(node);
        });
        list.sort(function (data1, data2) {
            if (data1.x < data2.x) {
                return -1;
            } else if (data1.y == data2.y) {
                return 0;
            } else {
                return 1;
            }
        })
        return list;
    }

    getDescMaxWidth() {
        let nodeList = this.getOrderNodes();
        let width = 0;
        let nodeListLength = nodeList.length;

        for (let index = 0; index < nodeListLength; index++) {
            if (index != nodeListLength -1) {
                let timeNode = nodeList[index];

                let desc = timeNode.desc;
                width = Math.max(width, desc.width) + this.UiUtil.dip2px(8)
            }
        }
        return width;
    }

}
export default TimeLineBridgeLayout
